export const API_VERSION = Object({
    'dev': '/backend/api/v1',
    'prod': '/backend/api/v1'
});
